import React from 'react';
import Icon from '../../../components/AppIcon';

const OfflineSyncBanner = ({ isOnline, pendingCount, syncing, lastSyncTime, onManualSync }) => {
  if (isOnline && pendingCount === 0 && !syncing) return null;

  const formatTime = (date) => {
    if (!date) return '';
    return date?.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' });
  };

  if (!isOnline) {
    return (
      <div className="flex items-center gap-3 px-4 py-3 bg-yellow-50 border border-yellow-200 rounded-xl mb-4">
        <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
          <Icon name="WifiOff" size={16} color="#d97706" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-yellow-800">Working Offline</p>
          <p className="text-xs text-yellow-600">
            {pendingCount > 0
              ? `${pendingCount} change${pendingCount !== 1 ? 's' : ''} will sync when connected`
              : 'Changes will sync automatically when connected'}
          </p>
        </div>
        {pendingCount > 0 && (
          <span className="text-xs font-bold bg-yellow-200 text-yellow-800 px-2 py-1 rounded-full flex-shrink-0">
            {pendingCount}
          </span>
        )}
      </div>
    );
  }

  if (syncing) {
    return (
      <div className="flex items-center gap-3 px-4 py-3 bg-blue-50 border border-blue-200 rounded-xl mb-4">
        <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
          <div className="w-4 h-4 border-2 border-blue-500 border-t-transparent rounded-full animate-spin" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-blue-800">Syncing Changes...</p>
          <p className="text-xs text-blue-600">Uploading {pendingCount} pending item{pendingCount !== 1 ? 's' : ''}</p>
        </div>
      </div>
    );
  }

  if (isOnline && pendingCount > 0) {
    return (
      <div className="flex items-center gap-3 px-4 py-3 bg-orange-50 border border-orange-200 rounded-xl mb-4">
        <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center flex-shrink-0">
          <Icon name="RefreshCw" size={16} color="#ea580c" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-sm font-semibold text-orange-800">Pending Sync</p>
          <p className="text-xs text-orange-600">{pendingCount} item{pendingCount !== 1 ? 's' : ''} waiting to sync</p>
        </div>
        <button
          onClick={onManualSync}
          className="text-xs font-semibold bg-orange-200 text-orange-800 px-3 py-1.5 rounded-lg hover:bg-orange-300 transition-colors flex-shrink-0"
        >
          Sync Now
        </button>
      </div>
    );
  }

  return null;
};

export default OfflineSyncBanner;
